<template>
    <div id="knowledge-base-category-page">

        <div class="vx-row mt-8 match-height">

            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
                <vx-card>
                    <h4 class="mb-4">Tempo Bugs</h4>
                    <div v-for="tmp of tempos_bug" :key="tmp.id" class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span :style="{lineHeight: '2.8em'}">{{tmp.nome}}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full" :class="{'ivu-form-item-error': tmp.error}">
                            <div class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type ivu-input-group ivu-input-group-default ivu-input-group-with-append ivu-input-with-search">
                                <the-mask class="ivu-input ivu-input-default"
                                          v-model="tmp.tempo"
                                          mask="#####" :masked="true" :disabled="tmp.loading" />
                                <div class="ivu-input-group-append ivu-input-search" style="">
                                    <div v-if="tmp.loading" class="spin-icon-load">
                                        <Icon type="ios-loading" size=18></Icon>
                                    </div>
                                    <Icon v-else type="ios-checkmark" size=18 @click="changeTime(tmp.id)"></Icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base" v-for="section in sections" :key="section.id">
                <vx-card>
                    <h4 class="mb-4">{{ section.title }}</h4>
                    <ul class="bordered-items">
                        <li v-for="que in section.questions" :key="que.question" class="py-2"><router-link :to="que.answerUrl">{{ que.question }}</router-link></li>
                    </ul>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
    import { sortBy } from "lodash";

    export default {
        name: "Configuracoes",
        components: {
            TheMask: () => import("vue-the-mask").then(({TheMask}) => TheMask)
        },
        data() {
            return {
                sections: [],
                tempos_bug: [
                    {
                        id: 1,
                        nome: "Baixa",
                        tempo: 0,
                        loading: false,
                        error: false,
                    },
                    {
                        id: 2,
                        nome: "Média",
                        tempo: 0,
                        loading: false,
                        error: false,
                    },
                    {
                        id: 3,
                        nome: "Alta",
                        tempo: 0,
                        loading: false,
                        error: false,
                    },
                ]
            }
        },
        methods: {
            async changeTime(id) {
                const idx = this.tempos_bug.findIndex(o => o.id === id);
                try {
                    this.tempos_bug[idx].loading = true;
                    await this.$axios.put(`configuracoes/slatime/${id}`, {
                        tempo: this.tempos_bug[idx].tempo
                    });
                    this.tempos_bug[idx].loading = false;
                    this.$vs.notify({
                        title: "Tempo alterado",
                        color: "rgb(0,155,8)",
                        position: 'top-right'
                    });
                } catch (e) {
                    this.$vs.notify({
                        title: e.message || 'Erro',
                        color: "rgb(242, 19, 93)",
                        position: 'top-right'
                    });
                    this.tempos_bug[idx].error = true;
                    this.tempos_bug[idx].loading = false;
                }
            },
            async getTempos() {
                const {data} = await this.$axios.get('configuracoes/slatime');

                this.tempos_bug = sortBy(data.map(o => ({
                    ...o,
                    loading: false,
                })), ['id'], ['asc']);
            }
        },
        created() {
            this.getTempos();
        }
    }
</script>

<style scoped>
    .spin-icon-load{
        animation: animation-spin 1s linear infinite;
    }
    @keyframes animation-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
</style>
